import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);

  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 16 16' fill='none' className={className}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.6 8V5.6L14.4 8H13.6ZM13.6 14.4H2.4C1.9584 14.4 1.6 14.0416 1.6 13.6V9.6H4C4.4416 9.6 4.8 9.9584 4.8 10.4V11.2C4.8 12.084 5.516 12.8 6.4 12.8H9.6C10.484 12.8 11.2 12.084 11.2 11.2V10.4C11.2 9.9584 11.5584 9.6 12 9.6H14.4V13.6C14.4 14.0416 14.0416 14.4 13.6 14.4ZM2.4 5.6V8H1.6L2.4 5.6ZM4.8 1.6H11.2C11.6416 1.6 12 1.9584 12 2.4V8H11.2C10.316 8 9.6 8.716 9.6 9.6V10.4C9.6 10.8416 9.2416 11.2 8.8 11.2H7.2C6.7584 11.2 6.4 10.8416 6.4 10.4V9.6C6.4 8.716 5.684 8 4.8 8H4V2.4C4 1.9584 4.3584 1.6 4.8 1.6ZM14.4 3.2H13.6V1.6C13.6 0.716 12.884 0 12 0H4C3.116 0 2.4 0.716 2.4 1.6V3.2H1.6L0 8V14.4C0 15.284 0.716 16 1.6 16H14.4C15.284 16 16 15.284 16 14.4V8L14.4 3.2Z'
        fill={fillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 0H12C12.884 0 13.6 0.716 13.6 1.6V3.2H14.4L16 8V14.4C16 15.284 15.284 16 14.4 16H1.6C0.716 16 0 15.284 0 14.4V8L1.6 3.2H2.4V1.6C2.4 0.716 3.116 0 4 0ZM4.8 1.6H11.2C11.6416 1.6 12 1.9584 12 2.4V8H11.2C10.316 8 9.6 8.716 9.6 9.6V10.4C9.6 10.8416 9.2416 11.2 8.8 11.2H7.2C6.7584 11.2 6.4 10.8416 6.4 10.4V9.6C6.4 8.716 5.684 8 4.8 8H4V2.4C4 1.9584 4.3584 1.6 4.8 1.6ZM2.4 8V5.6L1.6 8H2.4ZM13.6 8V5.6L14.4 8H13.6ZM2.4 14.4H13.6C14.0416 14.4 14.4 14.0416 14.4 13.6V9.6H12C11.5584 9.6 11.2 9.9584 11.2 10.4V11.2C11.2 12.084 10.484 12.8 9.6 12.8H6.4C5.516 12.8 4.8 12.084 4.8 11.2V10.4C4.8 9.9584 4.4416 9.6 4 9.6H1.6V13.6C1.6 14.0416 1.9584 14.4 2.4 14.4Z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
